module.exports = {"130706001":"城镇街道","130706002":"煤矿街道","130706200":"花园乡","130706201":"辛庄子乡","130706202":"定方水乡","130706203":"段家堡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130706.json
// module id = 268
// module chunks = 0